import React, { Component } from 'react'
import myImg from '../images/photo_2022-01-18_14-21-53.jpg'

export default class HomePage extends Component {
    hozirgi_yil = () => {
        return `${new Date().getFullYear()}`
    }
  render() {
    return (
        <section className='home'>
            <div className="imgBox">
                <div className="imgContent">
                    <img src={myImg} alt="" />
                    <span className='topRamka'></span>
                    <span className='bottomRamka'></span>
                </div>
            </div>
            <div className='text_box'>
                <h1 className='kirishSoz'>hello, my name is <span>Muhiddinjon</span></h1>
                <div className='animatis'>
                    <h1>I am</h1>
                    <ul>
                        {this.props.anmContentText.map((liConent) => (
                            <>
                                <li key={liConent} >{liConent}</li><br />                            
                            </>
                        ))}
                    </ul>
                </div>
                <p className='mini_paragraph'>
                    Assalomu Alekum mening ismim Muhiddinjon Kabraliev.
                    Men 2005-yilli tug'ilganman hozirgi vaqt - ({this.hozirgi_yil()})
                    Men 15 yoshimdan Beri dasturlashni o'rganmoqdaman.
                    O'ylaymanki Mening Web Sahifam sizga yoqadi va men haqimda sizga to'liq malumot bera oladi
                </p>
                <a className='rezumeBtn' href="https://rezume">
                    download rezume
                </a>
            </div>
        </section>
    )
  }
}
